import { render, staticRenderFns } from "./ClubSettingsList.vue?vue&type=template&id=7aaa05fc&lang=html&"
import script from "./ClubSettingsList.vue?vue&type=script&lang=js&"
export * from "./ClubSettingsList.vue?vue&type=script&lang=js&"
import style0 from "./ClubSettingsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VAutocomplete,VCard})
